import React from 'react';
import styled from 'styled-components';
import LOGO from '../images/logo-allegiant-blue.svg';
import Markdown from '../components/Markdown';

import { useTranslations } from '../graphql/components/ApplicationQueryProvider';

import { hook } from '@g4/automation-hooks';
import { COOKIES_DISABLED_MESSAGE } from '../../automationHooks.json';

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 2.2rem;
  margin: auto;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 500;
  & img {
    margin-top: 1.8rem;
    margin-bottom: 1.8rem;
    width: 150px;
  }
  & h1 {
    font-weight: 600;
    font-size: 1.2rem;
    margin-bottom: 2.4rem;
  }
  & p + p {
    margin-top: 0.2rem;
  }
  & ol {
    margin-top: 1.4rem;
    margin-bottom: 1.4rem;
    & li + li {
      margin-top: 0.3rem;
    }
    & p {
      display: inline-block;
    }
  }
  & a {
    color: #01579b;
  }

  ${props => props.theme.query.md} {
    font-size: 1rem;
    & h1 {
      font-size: 1.4rem;
      margin-bottom: 3rem;
    }
    & p + p {
      margin-top: 0.6rem;
    }
    & ol {
      margin-top: 1.8rem;
      margin-bottom: 1.8rem;
      & li + li {
        margin-top: 0.4rem;
      }
    }
  }
`;

const CookiesDisabledMessage = () => {
  // NOTE: in order to be able to see this message on your local env, change NODE_ENV to 'production' in the `yarn dev` script.
  // Run `yarn build` and then `yarn dev`. Access your localhost with all browser cookies turned off.

  const translations = useTranslations();
  const {
    cookiesDisabledMessageTitle,
    cookiesDisabledMessageContent,
  } = translations.errors;

  return (
    <MessageContainer {...hook(COOKIES_DISABLED_MESSAGE.hook)}>
      <img
        src={LOGO}
        alt="Allegiant Logo"
        {...hook(COOKIES_DISABLED_MESSAGE.hook, 'image')}
      />
      <h1 {...hook(COOKIES_DISABLED_MESSAGE.hook, 'title')}>
        {cookiesDisabledMessageTitle}
      </h1>
      <div {...hook(COOKIES_DISABLED_MESSAGE.hook, 'content')}>
        <Markdown source={cookiesDisabledMessageContent} />
      </div>
    </MessageContainer>
  );
};

export default CookiesDisabledMessage;
